import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { tv } from "tailwind-variants";
import Icon from "../../icons";
import cn from "../../utils/cn";
const checkboxVariants = tv({
    base: cn("peer size-4 shrink-0 rounded-sm border border-gray-8 ring-offset-background", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", "data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-white", "data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-white", "disabled:cursor-not-allowed disabled:border-gray-6 disabled:bg-gray-3", "data-[state=checked]:disabled:border-gray-6 data-[state=checked]:disabled:bg-gray-5", "data-[state=indeterminate]:disabled:border-gray-6 data-[state=indeterminate]:disabled:bg-gray-5"),
    variants: {
        size: {
            sm: "size-4 [&>span]:size-3",
            md: "size-5 [&>span]:size-3.5",
        },
    },
    defaultVariants: {
        size: "sm",
    },
});
const Checkbox = React.forwardRef(({ className, size, ...props }, ref) => (_jsx(CheckboxPrimitive.Root, { ref: ref, className: cn(checkboxVariants({ size }), className), ...props, children: _jsx(CheckboxPrimitive.Indicator, { className: "mx-auto flex items-center", children: props.checked === "indeterminate" ? _jsx(Icon, { name: "minus" }) : _jsx(Icon, { name: "check" }) }) })));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export default Checkbox;
